import { useRef, useState } from "react";
import { CTAButton } from "lib/components/CTAButton";
import { CheckboxButton } from "lib/components/Checkbox";
import { KeyValue } from "lib/components/KeyValue";
import { fetchData } from "lib/helpers/fetchData";
import { getApiUrl } from "lib/helpers/getApiUrl";
import { getFormValues } from "lib/helpers/getFormValues";
import { StyledForm } from "lib/styles/general";

export const ServiceToggle = ({ data, reload, appKey }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);

  const enabled = !!data?.apps?.[appKey]?.enabled;
  const enabledStatus = enabled ? "Enabled" : "Disabled";

  const handleSubmit = async () => {
    setIsLoading(true);
    let { enabled } = getFormValues(formRef.current);
    await fetchData(`${getApiUrl("ADMIN_API")}/customers/${data?.id}/apps/${appKey}`, JSON.stringify({ enabled }), "PUT");
    setIsLoading(false);
    setIsEditMode(false);
    reload();
  };

  return (
    <div style={{ position: "relative" }}>
      <StyledForm ref={formRef}>
        <section style={{ paddingTop: 0 }}>
          <KeyValue
            text="Service Status"
            wrap={false}
            value={
              <CheckboxButton
                name="enabled"
                subtle
                showWhenNull
                label={isEditMode ? "Is Enabled?" : enabledStatus}
                defaultChecked={enabled}
                readOnly={!isEditMode}
              />
            }
          />
        </section>
      </StyledForm>
      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "1rem" }}>
        {isEditMode ? (
          <>
            <CTAButton isSecondary onClick={() => setIsEditMode(false)} disabled={isLoading}>
              Cancel
            </CTAButton>
            <CTAButton isLoading={isLoading} onClick={handleSubmit}>
              Save
            </CTAButton>
          </>
        ) : (
          <CTAButton onClick={() => setIsEditMode(true)}>Edit</CTAButton>
        )}
      </div>
    </div>
  );
};
